export default __webpack_public_path__ + "static/media/package-6.1dc5483d.png";